import State from 'store/State';
import { selectBlotterState } from '../selectors';
import { useSelector } from 'react-redux';
import Order from 'communication/types/order/Order';
import { OrderFilterResult } from './BlotterFilteredOrdersState';
import { IndexedArray } from 'utils/arrays/arrayUtils';

export const NoStateTicks = -1;
const EmptyResults: IndexedArray<OrderFilterResult> = [];

const selectBlotterFilteredOrders = (state: State, widgetKey: string) => {
    const componentsState = selectBlotterState(state, widgetKey);
    return componentsState?.filteredOrders;
};

const selectBlotterFilteredOrdersResultsTicks = (
    state: State,
    widgetKey: string
) => {
    return (
        selectBlotterFilteredOrders(state, widgetKey)?.resultsTicks ??
        NoStateTicks
    );
};

export const selectBlotterFilteredOrdersResults = (
    state: State,
    widgetKey: string
) => {
    return (
        selectBlotterFilteredOrders(state, widgetKey)?.results ?? EmptyResults
    );
};

export const useSelectBlotterFilteredOrdersResultsTicks = (widgetKey: string) =>
    useSelector((state: State) =>
        selectBlotterFilteredOrdersResultsTicks(state, widgetKey)
    );

export const useSelectBlotterFilteredOrdersResults = (widgetKey: string) =>
    useSelector((state: State) =>
        selectBlotterFilteredOrdersResults(state, widgetKey)
    );

export function toOrderResults(
    orders: Order[] | undefined,
    filterResults: IndexedArray<OrderFilterResult>
): Order[] {
    if (!orders) {
        return [];
    }

    return filterResults
        .filter((r) => r?.passes)
        .map((r) => orders[r!.idx])
        .filter((o) => !!o);
}
